import '../styles/App.css';
import '../styles/stakeheader.css';
import React from "react";


const StakeHeader = params => {
    return (
        <div className="stakeheader">
            <div className='stakeheader__title'>
                <h1>Welcome to Trooprz & Friendz NFT Staking</h1>
                <h3>{!params.claimableReward ? 0 : params.claimableReward} $TRPZ Claimable</h3>
                <button onClick={() => {
                    if (params.claimableReward !== 0) {
                        params.claimRewards()
                    }
                }}
                        disabled={!params.claimableReward}
                        className={!params.claimableReward ? 'button disabled' : 'button'}>Claim Now
                </button>
            </div>
        </div>
    )
}

export default StakeHeader;
